/*
# -----------------------------------------------------------------------------
# Component: treatyListMixin.js
# Author: ssy@pst.sg
# Created Date: 23/Nov/2020
# Comments: Responsible for all data table related functionality
# -----------------------------------------------------------------------------
*/

import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'

export const treatyListMixin = {
  data() {
    return {
      retroRIList: [
        // { text: '100%', value: '' }
      ],
      retroRIUwYrList: [
        { text: 'Add New Year', value: 'New' }
      ],
      ttyStmtLnList: [],
      totalItemsTtyStmtLn: 0,
      ttyStmtLnList2: [],
      totalItemsTtyStmtLn2: 0,
      selectedTtyStmtLnColumns: ['riRef', 'brkRef', 'uwYr', 'stmtLnType', 'stmtLnSeq', 'busAnDesc', 'amtA', 'aedADisp', 'amt1A', 'amt2A'],
      ttyStmtLnColumns: [
        { text: 'Outwards Company', value: 'riRef' },
        { text: 'Acct No. Sfx', value: 'acctNoSfx' },
        { text: 'Outwards Broker', value: 'brkRef' },
        { text: 'Broker Acct No. Sfx', value: 'brkAcctNoSfx' },
        { text: 'UW Yr', value: 'uwYr' },
        { text: 'Statement Line', value: 'stmtLnType' },
        { text: 'Line Seq No.', value: 'stmtLnSeq' },
        // { text: 'BAC', value: 'busAn' },
        { text: 'BAC', value: 'busAnDesc' },
        { text: '100% Amount', value: 'amtA' },
        { text: 'A/E', value: 'aedADisp' },
        { text: 'Amt 1', value: 'amt1A' },
        { text: 'Amt 2', value: 'amt2A' },
        { text: 'Amt 3', value: 'amt3A' },
        { text: 'Amt 4', value: 'amt4A' },
        { text: 'Amt 5', value: 'amt5A' },
        { text: 'Amt 6', value: 'amt6A' }
      ],
      paginationTtyStmtLn: {
        sortBy: ['uwYr'],
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  computed: {
    listTtyStmtLn() {
      let result = []
      for (const selectedColumn of this.selectedTtyStmtLnColumns) {
        let findCol = this.ttyStmtLnColumns.find(a => selectedColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    }
  },
  watch: {
    // TtyStmtLn
    'paginationTtyStmtLn': function (value) {
      this.getTtyStmtLnList(this.ttyHeaderForm)
    }
  },
  mounted() {
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
